import React from 'react';
import CircleLinearImg from './assets/circle-linear.png';
import styles from './VerticalStepperWithLine.module.scss';

const STEPS = [
  {
    key: 1,
    title: 'メールアドレスと携帯電話番号を入力',
    description:
      'ショップでペイディを選択し、メールアドレスと携帯電話番号を入力してください。',
  },
  {
    key: 2,
    title: '認証コードを入力して購入完了',
    description: 'SMSで届く4桁の認証コードを入力して購入を完了させてください。',
  },
  {
    key: 3,
    title: '翌月ご請求金額をお知らせ',
    description: '翌月1日～5日の間にメールやSMSでご請求金額をお知らせします。',
  },
  {
    key: 4,
    title: '翌月27日までにお支払い',
    description:
      'コンビニ払い、口座振替、銀行振込でお支払いください。すぐ払いを利用して、当月中にお支払いいただくことも可能です。',
  },
];

/**
 * steps: Array of { image: string, title: string, description: string }
 */
export default function VerticalStepperWithLine({ steps = STEPS }) {
  return (
    <div className={styles.verticalStepper}>
      {steps.map((step, idx) => (
        <div className={styles.step} key={idx}>
          <div className={styles.iconWrapper}>
            <div src={step.image} alt={step.title} className={styles.icon}>
              <img alt="alter" src={CircleLinearImg} width={40} height={40} />
              <p className={styles.number}>{idx + 1}</p>
            </div>
            {idx !== steps.length - 1 && <div className={styles.line} />}
          </div>
          <div className={styles.content}>
            <div className={styles.title}>{step.title}</div>
            <div className={styles.description}>{step.description}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
